import { Calendar } from "antd";
import Timer from "helpers/timer";
import { sum } from "lodash";
import moment from "moment";
import React, { useMemo, useRef, useState } from "react";
import EachCellCustom from "../EachCellCustom";
import "./styles.less";

const CalendarRender = (props) => {
  const {
    value: val,
    onSelect = () => { },
    onChangeCalendar = () => { },
    onChangeDateValue = () => {},
    whPlanSales = [],
    disablePopover = false,
    defaultValueKey = 'planQty',
    isShowMultiple = false,
    validRange
  } = props;

  const value = useMemo(() => {
    if(!(val instanceof Array)){
       return [val];
    }

    return val;
  }, [val])



  //! State
  const timer = useRef(new Timer());
  const [isChangeMonth, setIsChangeMonth] = useState(true);

  //! Effect
  
  //! Function
  const onPanelChange = (e) => {
    // Anti open Popover when Calender change Month (Error Cell)
    setIsChangeMonth(false)
    if(onChangeCalendar) {
      const newDateRange = [moment(e).startOf('month'), moment(e).endOf('month')];
      onChangeCalendar(newDateRange);
    }
    timer.current.debounce(() => {setIsChangeMonth(true)}, 200);
  };

  const getDefaultValidRange = () => {
    const startDate = value && value[0];
    const endDate = value && value[1];
    if (startDate && endDate) {
      const result = [startDate, endDate];
      return result;
    }
    return [moment().add(0, "year"), moment().add(1, "year")];
  };

  const getValueRenderFn = (items) => {
    if(isShowMultiple){
      return () => 
      (
        <div className="d-flex flex-column">
          {
            items.map((item, index) => <div key={index}>{`${item?.planQty} (${item?.goodReceiptCode}) ${defaultValueKey !== 'planQty' ? " / " + item?.soldQty || 0 : ""}`}</div>)
          }
        </div>
      );
    }

    return null;
  }

  //! Render
  return (
    <div className={`calendar-custom`}>
      <Calendar
        validRange={validRange && validRange.length ? validRange : getDefaultValidRange()}
        value={value ? value[0] : moment()}
        onSelect={onSelect}
        onPanelChange={onPanelChange}
        dateFullCellRender={(dateMomment) => {
          const items = whPlanSales.filter((el) => moment(dateMomment).isSame(moment(el.planUseDate), "D"));

          let defaultValue = null;
          let min = 0;
          if(items?.length){
            defaultValue = sum(items.map(x=> x?.[defaultValueKey]));
            min = sum(items.map(x=> x?.usedQuantity || 0));
          }
          
          return (
            isChangeMonth && 
              <EachCellCustom
                defaultValue={defaultValue}
                date={dateMomment}
                placeholderEachCell="Vui lòng nhập số lượng..."
                titleEachCell="Lựa chọn số lượng"
                onChangeValue={onChangeDateValue}
                min={min}
                valueRender={getValueRenderFn(items)}
                disablePopover={disablePopover}
              />
          );
        }}
      />
    </div>
  );
};

export default CalendarRender;
